import React from 'react'

function WelcomeBox() {
  return (
    <div className="bannerbox">
        <h6 style={{textAalign:"center"}}>A tool that allows you to batch send ERC20 tokens, ERC721 and ERC1155 NFT's</h6>
        <center><h2> Welcome to <em>Multi</em>Tokendrop</h2></center>       
    </div>
  )
}

export default WelcomeBox